import { render, staticRenderFns } from "./AsiaGaming.vue?vue&type=template&id=0b6ad87e&scoped=true"
import script from "./AsiaGaming.vue?vue&type=script&lang=js"
export * from "./AsiaGaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ad87e",
  null
  
)

export default component.exports